module.exports = __webpack_public_path__ + "static/img/nawiPoczatek-ON.b48a5b2d.png";